/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPennant2 = createReactComponent("pennant-2", "IconPennant2", [
  ["path", { d: "M16 21h-4", key: "svg-0" }],
  ["path", { d: "M14 21v-18", key: "svg-1" }],
  ["path", { d: "M14 4l-9 4l9 4", key: "svg-2" }]
]);

export { IconPennant2 as default };
//# sourceMappingURL=IconPennant2.js.map
